import { useSuspenseQuery } from '@tanstack/react-query';
import { subDays } from 'date-fns';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';
import { dateAsIsoString } from '@/utils/dateAsIsoString';

export const RECENT_AWARDS_DAYS = 30;
const RECENT_CLEARS_LIMIT = 14;

export type RecentClearsResponse =
  paths['/supplier-market-clears/recent']['get']['responses']['200']['content']['application/json'];
export type RecentClear = RecentClearsResponse['data']['clears'][number];

export async function fetchRecentAwards(): Promise<RecentClear[]> {
  const startClearCreatedDate = dateAsIsoString(subDays(new Date(), RECENT_AWARDS_DAYS));

  const data = await apiClient
    .get('api/supplier-experience/supplier-market-clears/recent', {
      searchParams: { limit: RECENT_CLEARS_LIMIT, startClearCreatedDate },
    })
    .json<RecentClearsResponse>();

  const clears = data?.data?.clears ?? [];
  return [...clears].sort((a, b) => b.clearTime.localeCompare(a.clearTime));
}

/**
 * Hook to fetch recent awards (market clears) from the last 30 days for the user.
 */
const useRecentAwards = () =>
  useSuspenseQuery({
    queryKey: ['recent-awards'],
    queryFn: fetchRecentAwards,
  });

export default useRecentAwards;
